<template>
<div class="chapter">
<div class="inner_page">
<h2 class="chno">Acknowledgments</h2>
<p class="noindent">This book could not have been written without God’s help and hard work from different people. I owe an enormous debt of gratitude to those who played a part in bringing it to fruition.</p>
<p class="indent">Many thanks to my editors, Kelly Madrone and Andrew Szanton, for your steadfast encouragement and for helping me to put my thoughts and heart on paper.</p>
<p class="indent">For granting interviews, I want to thank Carolyn Moore, Clay Thomas, Caryn Young, Christina Astore, and Joey Schwab.</p>
<p class="indent">For reading the book, or sections of the book in draft form, and offering helpful additions, suggestions, and corrections, I want to thank Ann Spangler, Betsy Rapoport, Steve Knopik, Rebecca Abrahamson, Callie Chappell-Nicholas, Con Nicholas, and David Zapata.</p>
<p class="indent">The writings of James Tyrrell were also helpful to the scenes I wrote about South Africa.</p>
<p class="indent">To Tom Dean, my agent and now friend, I am grateful for your belief in my story along with your guidance and support. And thank you to Morgan James Publishing for taking my book the last mile to bookstores far and wide.</p>
<p class="indent">And finally, for love and support day in and day out, I want to thank my husband, Steve Knopik, and our son, Rogers Knopik. You are the true loves of my life.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm05.vue?21313b86